import isPlainObject from '../utility/isPlainObject';

function keyToSnakeCase(key) {
  return key.replace(/[A-Z]/g, ([char]) => `_${char.toLowerCase()}`);
}

function transformFormDateToSnakeCase(params) {
  const transformedFormData = new FormData();
  for (const [key, value] of params.entries()) {
    transformedFormData.append(keyToSnakeCase(key), value);
  }
  return transformedFormData;
}

/**
 * Transforms an object's camelCase properties to snake case deeply
 * @param {object} params
 * @returns {object} Transformed object with camelCase properties
 */
export default function transformToSnakeCase(params) {
  if (Array.isArray(params)) {
    return params.map(transformToSnakeCase);
  }
  if (params instanceof FormData) {
    return transformFormDateToSnakeCase(params);
  }
  if (!isPlainObject(params)) {
    return params;
  }
  const transformedParams = {};
  const keys = Object.keys(params);

  for (const key of keys) {
    const finalKey = keyToSnakeCase(key);
    if (isPlainObject(params[key])) {
      transformedParams[finalKey] = transformToSnakeCase(params[key]);
    } else if (Array.isArray(params[key])) {
      transformedParams[finalKey] = params[key].map(transformToSnakeCase);
    } else {
      transformedParams[finalKey] = params[key];
    }
  }

  return transformedParams;
}
